import { render, staticRenderFns } from "./ReviewImageEditor.vue?vue&type=template&id=63cc4d24&scoped=true"
import script from "./ReviewImageEditor.vue?vue&type=script&lang=js"
export * from "./ReviewImageEditor.vue?vue&type=script&lang=js"
import style0 from "./ReviewImageEditor.vue?vue&type=style&index=0&id=63cc4d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc4d24",
  null
  
)

export default component.exports